import React from "react";
import {
  MuiTextField,
  MuiTypography,
  MuiGrid,
  MuiButton,
  MuiInputAdornment,
  MuiEmailIcon, MuiPersonIcon,
  MuiPhoneIcon, muiWithStyles
} from "../../../ui";
import theme from "../../../../assests";

import MaterialUIForm from "material-ui-form";

import { Link } from 'react-router-dom';
import routes from '../../../navigation/Routes'
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/plain.css';
import startsWith from 'lodash.startswith';
import * as Constants from '../../../../constants';
class UpdateUserProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: JSON.parse(JSON.stringify(props.userInformation)),
      error: "",
      phoneNumber: "",
    };

    this.handleOnChange = this.handleOnChange.bind(this)
  }

  handleOnChange(value, data, event) {
    let profile = this.state.profile;
    let aPhone = value.replace(/[^0-9]+/g, '').slice(data.dialCode.length);
    profile['phoneNumber'] = value.replace(/[- ()]/g, '');
    this.setState({
      profile: profile,
      phoneNumber: aPhone
    });
  }

  handleChange = name => event => {
    let profile = this.state.profile
    profile[name] = event.target.value
    this.setState({
      profile: profile
    });
  }

  validate = () => {
    const i18n = this.props.i18n
    if (!(this.state.profile.firstName).match(/^[A-Za-z ]+$/)) {
      this.setState({ error: i18n.signup.firstNameValidation })
      return false;
    }
    if (!(this.state.profile.lastName).match(/^[A-Za-z ]+$/)) {
      this.setState({ error: i18n.signup.lastNameValidation })
      return false;
    }

    if (this.state.phoneNumber !== "") {
      if (this.state.phoneNumber.length != 10) {
        this.setState({ error: i18n.signup.phoneNumberValidation });
        return false;
      }
    }
    this.setState({ error: "" })
    return true;

  };
  onSubmit = () => {
    let formValid = this.validate();
    if (formValid === true) {
      this.updateUserProfile();

    }
  }
  updateUserProfile = async () => {
    try {
      let tempData = JSON.parse(JSON.stringify(this.state.profile));
      let phoneNumber = ""
      let result = {};
      if (this.props.userInformation.firstName !== this.state.profile.firstName && this.props.userInformation.phoneNumber !== this.state.profile.phoneNumber) {
        tempData.name = 'Name and Phone number'
      }
      else if (this.props.userInformation.firstName !== this.state.profile.firstName || this.props.userInformation.lastName !== this.state.profile.lastName) {
        tempData.name = 'Name'
      }
      else if (this.props.userInformation.phoneNumber !== this.state.profile.phoneNumber) {
        tempData.name = 'Phone number'
      }
      phoneNumber = "+" + tempData.phoneNumber
      tempData.phoneNumber = phoneNumber

      // let userData = JSON.stringify(tempData);
      result = await this.props.updateUserProfile(tempData);

      if (result != {}) {
        window.location.href = "/";
      } else {
        this.setState({ error: "Internal Error", spinnerFlag: false });
      }
    } catch (error) {
      console.log("got error frm the server ", error);
      this.setState({ error: error.message, spinnerFlag: false });
    }
  };

  render() {
    const { classes, i18n } = this.props;

    return (
      <MuiGrid container xs={12} >

        <MaterialUIForm className={classes.form}>
          <MuiGrid container xs={12} justify="center" >
            <MuiGrid container xs={6} >

              <MuiGrid item xs={12} >

                <MuiTypography variant={theme.typographyStyles.H6} className={classes.titleStyle} > Update User Profile</MuiTypography>
              </MuiGrid>

              <MuiGrid container xs={12}  >


                <MuiGrid item xs={12} >
                  <MuiTextField
                    id="firstName"
                    label="First Name"
                    className={classes.textFieldStyle}

                    onChange={this.handleChange("firstName")}
                    margin="normal"
                    placeholder={i18n.signup.firstNamePlaceHolder}
                    data-validators="isRequired,isAlpha"
                    type="text"
                    required
                    value={this.state.profile.firstName}
                    InputProps={{
                      startAdornment: (
                        <MuiInputAdornment position="end">
                          <MuiPersonIcon color="primary" />
                        </MuiInputAdornment>
                      ),
                    }}
                  />
                </MuiGrid>
                <MuiGrid item xs={12}>
                  <MuiTextField
                    id="lastName"
                    label="Last Name"
                    className={classes.textFieldStyle}

                    onChange={this.handleChange("lastName")}
                    margin="normal"
                    placeholder={i18n.signup.lastNamePlaceHolder}
                    type="text"
                    data-validators="isRequired,isAlpha"
                    required
                    value={this.state.profile.lastName}
                    InputProps={{
                      startAdornment: (
                        <MuiInputAdornment position="end">
                          <MuiPersonIcon color="primary" />
                        </MuiInputAdornment>
                      ),
                    }}
                  /></MuiGrid>
                <MuiGrid item xs={12}>
                  <MuiTextField
                    id="email"
                    label="Email"
                    className={classes.textFieldStyle}


                    onChange={this.handleChange("email")}
                    margin="normal"
                    placeholder={i18n.signup.emailPlaceHolder}
                    type="email"
                    value={this.state.profile.email}
                    data-validators="isRequired, isEmail"

                    disabled
                    InputProps={{
                      startAdornment: (
                        <MuiInputAdornment position="end">
                          <MuiEmailIcon color="primary" />
                        </MuiInputAdornment>
                      ), readOnly: true,
                    }}
                  /></MuiGrid>
                <MuiGrid item xs={12}>
                  {/* <MuiTextField
                    id="phoneNumber"
                    label="Phone Number"
                    className={classes.textFieldStyle}


                    onChange={this.handleChange("phoneNumber")}
                    type="text"
                    data-validators="isRequired,text"
                    margin="normal"
                    placeholder="Enter Phone number"
                    value={this.state.profile.phoneNumber}
                    InputProps={{
                      startAdornment: (
                        <MuiInputAdornment position="end">
                          <MuiPhoneIcon color="primary" />
                        </MuiInputAdornment>
                      )
                    }}
                  /> */}
                  <PhoneInput
                    id="phoneNumber"
                    isValid={(inputNumber, undefined, countries) => {
                      return countries.some((countryObj) => {
                        return startsWith(inputNumber, countryObj.dialCode) || startsWith(countryObj.dialCode, inputNumber);
                      });
                    }}
                    onChange={this.handleOnChange}
                    inputClass='phone-input-signup'
                    //inputStyle={theme.muiTextFieldStyleForMainScreen}
                    placeholder={i18n.signup.phoneNumberPlaceHolder}
                    containerClass="phone-input-update-profile-container react-tel-input"
                    // disabled={this.props.isEditNotAllowed}
                    // disableDropdown={this.props.isEditNotAllowed}
                    label="Phone Number"
                    value={this.state.profile.phoneNumber}
                    country={Constants.PHONE_DEFAULT_COUNTRY_CODE}
                    inputProps={{

                      name: 'phoneNumber',
                      required: true
                    }}
                  />
                  <br /></MuiGrid>

                <br /><br />
                <MuiTypography
                  variant={theme.typographyStyles.CAPTION}
                  color="error"
                >
                  {this.state.error}
                </MuiTypography>
                <MuiGrid container xs={12} justify='center' alignContent='center' spacing={1}>
                  <MuiGrid item  >
                    <Link to={routes.main} className={classes.textDecorationNone}>
                      <MuiButton
                        style={theme.secondaryButtonStyle} >Cancel</MuiButton>
                    </Link>

                  </MuiGrid>

                  <MuiGrid item >
                    <MuiButton
                      id="UpdateUserProfile"
                      style={theme.primaryButtonStyle}
                      onClick={() => this.onSubmit()}
                    >
                      Update Profile
                </MuiButton></MuiGrid>



                </MuiGrid>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>
        </MaterialUIForm>
      </MuiGrid>

    );
  }
}


const styles = theme => ({

  form: {
    width: '100%',
    marginTop: '10vh'
  },
  titleStyle: { fontWeight: 600 },
  textFieldStyle: {
    width: '80%'
  },

  textDecorationNone: {
    textDecoration: 'none'
  },

});
export default muiWithStyles(styles)(UpdateUserProfile);
